import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Component/Sidebar";
import Header from "./Header";
import { FileContext } from "../context/FileContext";
import { HiMenu } from "react-icons/hi";

const Layout = () => {
  const { files, setFiles } = useContext(FileContext);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [fileType, setFileType] = useState("Folder");
  const [currentFolder, setCurrentFolder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 relative">
      {/* Mobile Sidebar Toggle Button */}
      <div className="absolute top-6 left-4 z-50 md:hidden">
        {!sidebarOpen && (
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-3xl text-gray-800"
          >
            <HiMenu />
          </button>
        )}
      </div>

      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        files={files}
        setFiles={setFiles}
        isCreateModalOpen={isCreateModalOpen}
        setIsCreateModalOpen={setIsCreateModalOpen}
        fileType={fileType}
        setFileType={setFileType}
        fileInput={fileInput}
        setFileInput={setFileInput}
        isLoading={isLoading}
        currentFolder={currentFolder}
        setCurrentFolder={setCurrentFolder}
      />

      <div className="flex flex-col flex-1 w-full">
        {/* Top Navbar */}
        <Header />
        {/* Page Content */}
        <main className="flex-1 overflow-auto bg-white p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
